import { useState, useEffect, useMemo, useCallback } from "react";


export default function AdorElUrl({ ador, updateAdorValue }) {

  const handleImageError = (e) => {
    e.target.src = '/dist/img/noimages.png'; // Provide the path to your default or empty image
  };

  const handleChange = (e) => {
    e.stopPropagation();
    // Auto format text before update using ador.format_text

    updateAdorValue(ador.ador_name, "user_value", e.target.value);
  }

  const validateAdor = () => {
    // Check required with ador.is_required

    // Check format with ador.validation
  }

  //debugger;
  return ador && ador.hidden == 0 && (
    <div className="row">
      <div className="col">
        <label className="form-label">{ador.label}</label>
        <input type="text" name={ador.ador_name}
          id={ador.ador_name} class="form-control"
          placeholder={ador.placeholder}
          value={ador.user_value}
          onChange={handleChange}
          readOnly={ador.readonly}
          required={ador.required}
        />
      </div>
    </div>
  );
}
